<!--
 * @Description:
 * @Author: 裴孚
 * @Date: 2022-10-08 09:10:31
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-05-30 19:25:02
 * @FilePath: \ZHXY_VUE3.0\src\App.vue
-->
<template>
  <div class="layout_main">
    <RouterView />
  </div>
</template>
<script setup>
// 错误捕获 ———— 忽略错误，不记录进日志
const e = window.error
window.onerror = function (errorMessage, scriptURI, lineNumber, columnNumber, error) {
  try {
    if (errorMessage === 'ResizeObserver loop limit exceeded') {
      throw new Error(errorMessage)
    }
  } catch (e) {}
}
</script>
<style lang="less">
</style>
